import React, { useState } from 'react';
import IconButton from '@mui/material/IconButton';
import Iconify from '@/components/media/iconify';
import axios from 'axios';
import { saveAs } from 'file-saver';
import { useCatchError } from '@/utils';

export default function DownloadButton({
  fileUrl,
  fileName,
  icon,
  color = 'primary',
}: {
  fileUrl: string;
  fileName: string;
  icon?: string;
  color?:
    | 'default'
    | 'inherit'
    | 'primary'
    | 'secondary'
    | 'success'
    | 'error'
    | 'info'
    | 'warning';
}) {
  const [downloading, setDownloading] = useState<boolean>(false);
  const catchError = useCatchError();

  return (
    <IconButton
      onClick={
        !downloading
          ? async () => {
              try {
                setDownloading(true);
                const response = await axios({
                  url: decodeURI(fileUrl),
                  method: 'GET',
                  responseType: 'blob',
                });
                saveAs(new Blob([response.data]), fileName);
              } catch (error) {
                catchError(error);
              } finally {
                setDownloading(false);
              }
            }
          : undefined
      }
      color={color}
    >
      <Iconify icon={icon || 'material-symbols:cloud-download'} />
    </IconButton>
  );
}
